// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.10-6UolF5LZuIaZoDlY8wmT/mode=imports,min/optimized/keen-slider.js'

class ProductCarousel extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.classUp()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      slides: {
        perView: 1,
      },
    })

    return slider
  }

  classUp () {
    if (!this.els.slides.element.classList.contains('keen-slider')) {
      this.els.slides.element.classList.add('keen-slider')
    }

    if (!this.els.slide.element.classList.contains('keen-slider__slide')) {
      this.els.slide.elements.forEach(el =>
        el.classList.add('keen-slider__slide'),
      )
    }
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
